export default __webpack_public_path__ + "static/media/dot-grid.c18d167e.png";